import { useLocation } from "react-router-dom";

export const useIsDetailPage = () => {
  const { pathname } = useLocation();
  const segments = pathname.split("/").filter(Boolean);

  if (segments.length === 0) {
    return { isDetail: false, parentPath: "/", backPath: "/" };
  }

  const lastSegment = segments[segments.length - 1];
  const isLastSegmentNumeric = /^[0-9]+$/.test(lastSegment);

  let isDetail = false;
  let parentPath = "/";
  let backPath = "/";

  if (segments.length >= 2 && isLastSegmentNumeric) {
    const secondLastSegment = segments[segments.length - 2];
    const id = lastSegment;

    // Define route mappings with proper typing
    const routeMappings: Record<string, string> = {
      "edit-order": `/my-orders/${id}`,
      "view-user": `/users/${id}`,
      "edit-product": `/products/${id}`,
    };

    // Check if current route has a mapping
    if (secondLastSegment in routeMappings) {
      backPath = routeMappings[secondLastSegment];
    } else {
      // Default back to parent path
      backPath = "/" + segments.slice(0, -1).join("/");
    }

    parentPath = "/" + segments.slice(0, -1).join("/");
    isDetail = true;
  } else {
    parentPath = "/" + segments.join("/");
    backPath = "/" + segments.join("/");
    isDetail = false;
  }

  return { isDetail, parentPath, backPath };
};
